export const botsService = {
  async getBots(token = null) {
    try {
      // Obtener el token del localStorage si no se proporciona como parámetro
      const authToken = token || localStorage.getItem('token');

      if (!authToken) {
        throw new Error('No hay token de autenticación');
      }

      const response = await fetch('/api/bots', {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${authToken}`,
          'Content-Type': 'application/json'
        }
      });

      if (!response.ok) {
        if (response.status === 401) {
          throw new Error('Token expirado o inválido');
        }
        throw new Error(`Error HTTP: ${response.status}`);
      }

      const data = await response.json();
      console.log('🤖 [Bots] Datos completos recibidos:', data);

      // Extraer todos los bots
      if (data.data && Array.isArray(data.data)) {
        console.log('📋 [Bots] Bots extraídos:', data.data);
        return data.data;
      } else {
        throw new Error('Estructura de datos inesperada en la respuesta de la API');
      }
    } catch (error) {
      console.error('Error al obtener bots:', error);
      throw error;
    }
  },

  // Formatear datos para el frontend
  formatDataForFrontend: (botsData) => {
    return botsData.map(bot => ({
      id: bot.id,
      codigo: bot.codigoBot || bot.codigo_bot,
      codigoEmpresa: bot.codigoEmpresa || bot.codigo_empresa,
      nombre: bot.nombre,
      genero: bot.genero,
      tipoAtencion: bot.tipoAtencion || bot.tipo_atencion,
      habilitado: (bot.habilitado === 1 || bot.habilitado === true),
      canal: bot.codigoCanal || bot.codigo_canal || 'whatsapp', // Default fallback
      createdAt: bot.createdAt || bot.created_at,
      updatedAt: bot.updatedAt || bot.updated_at
    }));
  }
};
